// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Aura Operations API
 * API to manage aura-operations
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HandlerOperationTriggerRequestParams } from './HandlerOperationTriggerRequestParams';
import {
  HandlerOperationTriggerRequestParamsFromJSON,
  HandlerOperationTriggerRequestParamsFromJSONTyped,
  HandlerOperationTriggerRequestParamsToJSON,
  HandlerOperationTriggerRequestParamsToJSONTyped,
} from './HandlerOperationTriggerRequestParams';

/**
 *
 * @export
 * @interface HandlerOperationTriggerRequest
 */
export interface HandlerOperationTriggerRequest {
  /**
   *
   * @type {string}
   * @memberof HandlerOperationTriggerRequest
   */
  operationName?: string;
  /**
   *
   * @type {HandlerOperationTriggerRequestParams}
   * @memberof HandlerOperationTriggerRequest
   */
  parameters?: HandlerOperationTriggerRequestParams;
}

/**
 * Check if a given object implements the HandlerOperationTriggerRequest interface.
 */
export function instanceOfHandlerOperationTriggerRequest(
  value: object,
): value is HandlerOperationTriggerRequest {
  return true;
}

export function HandlerOperationTriggerRequestFromJSON(
  json: any,
): HandlerOperationTriggerRequest {
  return HandlerOperationTriggerRequestFromJSONTyped(json, false);
}

export function HandlerOperationTriggerRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlerOperationTriggerRequest {
  if (json == null) {
    return json;
  }
  return {
    operationName:
      json['operation_name'] == null ? undefined : json['operation_name'],
    parameters:
      json['parameters'] == null
        ? undefined
        : HandlerOperationTriggerRequestParamsFromJSON(json['parameters']),
  };
}

export function HandlerOperationTriggerRequestToJSON(
  json: any,
): HandlerOperationTriggerRequest {
  return HandlerOperationTriggerRequestToJSONTyped(json, false);
}

export function HandlerOperationTriggerRequestToJSONTyped(
  value?: HandlerOperationTriggerRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    operation_name: value['operationName'],
    parameters: HandlerOperationTriggerRequestParamsToJSON(value['parameters']),
  };
}
